<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <!-- Events Table -->
        <event-management-table
          :items="eventList"
          :icon="tableIcon"
          :title="tableTitle"
          :buttons="tableButtons"
          :headers="tableHeaders"
          :no-data-message="noDataMessage"
          @edit="editItem"
          @delete="deleteItem"
          @toggleShowAll="handleShowAllClick"
          @addEvent="handleAddEventClick"
        />

        <!-- Delete Confirmation Dialog -->
        <delete-confirmation-dialog
          v-model="dialogDelete"
          title="Are you sure you want to delete event?"
          @confirm="deleteItemConfirm"
          @cancel="closeDelete"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import "izitoast/dist/css/iziToast.min.css"; // loading css
import iziToast from "izitoast/dist/js/iziToast.min.js"; // you have access to iziToast now
import { mapState, mapActions, mapMutations } from "vuex";
import EventManagementTable from "@/components/tables/EventManagementTable.vue";
import DeleteConfirmationDialog from "@/components/dialogs/DeleteConfirmationDialog.vue";

export default {
  name: "Events",
  components: {
    EventManagementTable,
    DeleteConfirmationDialog,
  },
  data: () => ({
    // Table configuration
    tableIcon: "mdi-flag",
    tableTitle: "Events",
    noDataMessage: "Updating with new data....",

    tableHeaders: [
      { text: "Event Name", value: "EventName" },
      { text: "Year", value: "Year" },
      { text: "ShowIn POS", value: "ShowInPOS" },
      { text: "Card Surcharge (%)", value: "CardSurchargePercentage" },
      { text: "Payment Profile", value: "PaymentProfile" },
      { text: "Printing Profile", value: "PrintingProfile" },
      { text: "Standard Drink Limit", value: "StandardDrinkLimit" },
      {
        text: "Drink Limit Profile",
        value: "StandardDrinkLimitEnforce",
      },
      { text: "Actions", value: "actions", sortable: false },
    ],

    dialogDelete: false,
    editedItem: [],
    defaultItem: [],
    managementEvents: [],
    showAll: false,
  }),

  computed: {
    ...mapState("filter", [
      "globalEventFilter",
      // 'allEvents',
      "filterYear",
    ]),
    ...mapState("filter", ["IsAdmin"]),

    tableButtons() {
      const buttons = [
        {
          name: "Toggle Show all",
          icon: "mdi-eye",
          function: "toggleShowAll",
        },
      ];

      if (this.IsAdmin) {
        buttons.push({
          name: "Add Event",
          icon: "mdi-plus",
          function: "addEvent",
        });
      }

      return buttons;
    },

    eventList: {
      get() {
        if (this.showAll) {
          return this.managementEvents;
        } else {
          console.log(
            "EVENT",
            this.managementEvents.filter(
              (event) => event.EventId === this.globalEventFilter.EventId
            )
          );
          return this.globalEventFilter
            ? this.managementEvents.filter(
                (event) => event.EventId === this.globalEventFilter.EventId
              )
            : this.managementEvents;
        }
      },
      set(val) {
        this.managementEvents = val;
      },
    },
  },

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    filterYear(year) {
      this.getAllEvents(year);
    },
  },

  created() {
    this.getAllEvents(this.filterYear);
  },

  methods: {
    ...mapMutations("filter", [
      //'setGlobalEventFilter',
      // 'setAllEvents'
    ]),
    ...mapActions("admin", ["createEvent", "getEventsData"]),

    getAllEvents: function (year) {
      try {
        this.getEventsData(year)
          .then((response) => {
            this.managementEvents = response;
          })
          .catch((err) => {
            console.log("err");
            console.log(err);
          });
      } catch (e) {
        console.log(e);
      }
    },

    editItem(item) {
      this.$router.push({
        // path: '/event_configuration',
        name: "Event Configuration",
        params: {
          id: item.EventId,
          eventData: item,
        },
      });
    },

    deleteItem(item) {
      this.editedIndex = this.eventList.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.eventList.splice(this.editedIndex, 1);

      try {
        if (this.editedItem.EventId) {
          let event_item = [
            {
              Type: "Event",
              Action: "delete",
              Properties: this.editedItem,
            },
          ];

          let submitEvent = {
            event_items: event_item,
          };
          this.createEvent(submitEvent)
            .then((response) => {
              console.log("response");
              console.log(response);
              iziToast.success({
                title: "Event",
                message: "Successfully deleted record!",
                position: "topRight",
              });
              this.getEventsData(this.filterYear);
            })
            .catch((err) => {
              console.log("err");
              console.log(err);
              iziToast.warning({
                title: "Event",
                message: "Failed to delete record!",
                position: "topRight",
              });
            });
        }
      } catch (e) {
        console.log(e);
      }

      this.closeDelete();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    handleAddEventClick: function () {
      this.$router.push({
        // path: '/event_configuration',
        name: "Event Configuration",
        params: { id: 0 },
      });
    },

    handleShowAllClick: function () {
      this.showAll = !this.showAll;
    },
  },
};
</script>
<style scoped>
h1 {
  color: #a09c94;
  font-family: sans-serif;
}
</style>
